// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoRecorder/style.css
// module id = 3672
// module chunks = 33